/**
 * Shown when a save was refused because the thing changed after it was opened -- in another tab,
 * by the other person, or by the agent. The choice is the person's: take what is there now, or
 * write theirs over it.
 */
export function StaleNotice({ onReload, onOverwrite }: { onReload: () => void; onOverwrite: () => void }) {
	return (
		<p className="banner error">
			内容已在别处修改{" "}
			<button className="ghost" onClick={onReload}>
				载入最新版本（放弃修改）
			</button>{" "}
			<button className="ghost" onClick={onOverwrite}>
				覆盖
			</button>
		</p>
	);
}
